import { Marker } from "react-map-gl/maplibre";
import * as React from "react";
import { Geo } from "../messages/Geo";
import { OnboardingVisitId, VisitBroadcastId, VisitInstanceId } from "../messages/ObjectIds";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { Visit } from "../system/AppState/AppVisitsState";
import { List } from "../utils/List";
import { HEART_FILLED_ICON, HOME_ICON } from "../utils/svgs_new";
import { ClockActionBannerData } from "./ClockActionBanner";
import { AppIcon } from "./Generic/AppIcon";
import { VisitsTab } from "./Main/MainTypes";
import AvailableVisitsMapForMedflytCaregiver from "./AvailableVisitsMapForMedflytCaregiver";
import AvailableVisitsMapForNonMedflytCaregivers from "./AvailableVisitsMapForNonMedflytCaregivers";
import BaseMap from "./BaseMap";
import { ComplianceBannerProps } from "./ComplianceBanner/ComplianceBanner";

export interface AvailableVisitsLiveMapProps {
  visits: List<Visit>;
  caregiver: AppCaregiver;
  currentSection: VisitsTab;
  finishOnboardingSection: React.ReactNode;
  clockActionBannerProps: ClockActionBannerData | null;
  visitsForPendingBanner: List<Visit.Available>;
  complianceBannerProps: ComplianceBannerProps | null;
  onConfirmAssignmentClick: (visitId: VisitBroadcastId, isReviewOnly: boolean) => void;
  onClickClockedInBanner: (details: VisitInstanceId) => void;
  onOnboardingVisitClick: (onboardingVisitId: OnboardingVisitId) => void;
  onCaseSettingsNavigationClick: () => void;
  onVisitClick: (visitBroadcastId: VisitBroadcastId) => void;
  onPendingConfirmationVisitClick: (visitId: VisitBroadcastId, isVisitConfirmed: boolean) => void;
}

export const AvailableVisitsLiveMap = (props: AvailableVisitsLiveMapProps) => {
  return (
    <BaseMap destination={props.caregiver.addressGeoLocation} zoom={9}>
      {props.caregiver.isCaregiverOfMedFlyt ? (
        <AvailableVisitsMapForMedflytCaregiver
          visits={props.visits}
          caregiver={props.caregiver}
          complianceBannerProps={props.complianceBannerProps}
          caregiverPosition={props.caregiver.addressGeoLocation}
          clockActionBannerProps={props.clockActionBannerProps}
          finishOnboardingSection={props.finishOnboardingSection}
          visitsForPendingBanner={props.visitsForPendingBanner}
          onVisitClick={props.onVisitClick}
          onClickClockedInBanner={props.onClickClockedInBanner}
          onConfirmAssignmentClick={props.onConfirmAssignmentClick}
          onOnboardingVisitClick={props.onOnboardingVisitClick}
          onCaseSettingsNavigationClick={props.onCaseSettingsNavigationClick}
          onPendingConfirmationVisitClick={props.onPendingConfirmationVisitClick}
        />
      ) : (
        <AvailableVisitsMapForNonMedflytCaregivers
          caregiver={props.caregiver}
          visits={props.visits}
          onVisitClick={props.onVisitClick}
          onOnboardingVisitClick={props.onOnboardingVisitClick}
        />
      )}
    </BaseMap>
  );
};

export const CaregiverPositionMapMarker = (props: { position: Geo }) => {
  return (
    /* I have to use inline style here, since I have to edit the marker's style directly (Wrapping it doesn't work) 
    and the marker does not accept className as an attribute **/
    <Marker latitude={props.position.lat} longitude={props.position.lng} style={{ zIndex: 10 }}>
      <div className="AvailableVisitsLiveMap__caregiverLocationIcon AvailableVisitsLiveMap__caregiverOriginIcon">
        <AppIcon icon={HEART_FILLED_ICON} />
      </div>
    </Marker>
  );
};

export const CaregiverHomeMapMarker = (props: { position: Geo }) => {
  return (
    <Marker latitude={props.position.lat} longitude={props.position.lng}>
      <div className="AvailableVisitsLiveMap__caregiverLocationIcon AvailableVisitsLiveMap__caregiverHomeIcon">
        <AppIcon icon={HOME_ICON} />
      </div>
    </Marker>
  );
};
